import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Autocomplete } from '@material-ui/lab'
import toUpperCamelCase from '../../view-model/Funciones/toUpperCamelCase'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import { Alert } from '@material-ui/lab';
import { Card, CardActionArea, CardActions, CardContent, TextField, CircularProgress, Grid, List, ListItem, ListItemText, LinearProgress, Divider } from '@material-ui/core';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputLabel, Paper, PaperProps } from '@material-ui/core'
import IViewCombo from "../../../presentation/view-interfaces/IViewCombo";
import { con } from "../../../application/entity/Rutas";
import { InsertTransferenciaLogic, ObtieneTransferenciaLogic } from '../Transferencia/transferencia.logic'
import { ComboBox, IIconProps, Panel, PanelType } from 'office-ui-fabric-react';
import { ObtieneTransferenciaItemPagoLogic } from '../Arancel/Arancel.logic';
import IViewComprobanteListado from '../../view-interfaces/IViewComprobanteListado';
import MensajeToken from '../../../Components/MensajeToken/MensajeToken';
type Props = {
  guid: string;
  idProcesoItemPago: number;
  idComprobante: number;
  openModalArchivos: boolean;
  onClickModal: any;
  bancos: any[];
  cuentas: any[];
  saldoFaltante: number;
}
const { validarRUT } = require('validar-rut')
const { formatterRut, cleanRut } = require('chilean-formatter')
const InfoComprobantes: React.FC<Props> = ({ guid, idProcesoItemPago, openModalArchivos, onClickModal, bancos, cuentas, saldoFaltante, idComprobante }) => {
  const history = useHistory();
  const location = useLocation();
  const _banco: IViewCombo = { ID: 0, descripcion: '' };
  const _cuenta: IViewCombo = { ID: 0, descripcion: '' };
  const [valBanco, setValBanco] = useState(_banco)
  const [valCuenta, setValCuenta] = useState(_cuenta)
  const [idBanco, setIdBanco] = useState(0)
  const [idTipoCuenta, setIdTipoCuenta] = useState(0)
  const [numTransaccion, setNumTransaccion] = useState('')
  const [rutCompletoTitular, setRutCompletoTitular] = useState('')
  const [rutTitular, setRutTitular] = useState(0)
  const [dvTitular, setDvTitular] = useState('')
  const [nombreTitular, setNombreTitular] = useState('')
  const [correoTitular, setCorreoTitular] = useState('')
  const [telefono, setTelefono] = useState('');
  const [montoComprobante, setMontoComprobante] = useState(0)
  const [idEstadoInicial] = useState(con.idEstadoInicialComprobante())
  const [usuario, setUsuario] = useState('MATWEB')
  const [estiloRut, setEstiloRut] = useState('form-control js-rut js-will-validate');
  const [guardando, setGuardando] = useState(true)
  const [guardado, setGuardado] = useState(false)
  const [errorVal, setError] = useState('');
  const [mnsjError, setMnsjError] = useState('');
  const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
  const [codNegocio, setCodNegocio] = useState(0)

  useEffect(() => {
    if (rutCompletoTitular.trim().length > 6) {
      if (validarRUT(rutCompletoTitular.trim())) {
        setRutCompletoTitular(formatterRut(rutCompletoTitular.trim()));
        setEstiloRut("form-control js-rut js-will-validate is-valid");

        setRutTitular(cleanRut(rutCompletoTitular, false))
        setDvTitular((rutCompletoTitular.split('-')[1]))
        setError('');
        setMnsjError("");
      } else {
        setEstiloRut("form-control js-rut js-will-validate is-invalid")
        setError("true");
        setMnsjError("Debe ingresar un rut válido.");
      }
    }
  }, [rutCompletoTitular])
  console.log(bancos, cuentas)
  useEffect(() => {
    let _tt = JSON.stringify(location.state);
    let _params = JSON.parse(_tt);
    setCodNegocio(_params.headers.codNegocio)
    if (idComprobante > 0) {
      ObtieneTransferenciaItemPagoLogic(selListaComprobantes, _params.headers, idProcesoItemPago, idComprobante)
    } else {
      setRutTitular(0)
      setDvTitular('')
      setRutCompletoTitular('')
      setNombreTitular('')
      setTelefono('')
      setCorreoTitular('')
      setIdBanco(0)
      setIdTipoCuenta(0)
      setValBanco(_banco)
      setValCuenta(_cuenta)
      setNumTransaccion('')
      setMontoComprobante(0)
      setEstiloRut('form-control js-rut js-will-validate')
      setError('')
      setMnsjError('')
    }
  }, [openModalArchivos])

  const selListaComprobantes = (error: Boolean, err: string, result: IViewComprobanteListado[]) => {
    //let pagadoTotal = 0;
    //let pagadoInd = 0;
    if (error === false) {
      console.log(result)
      result.map((e: IViewComprobanteListado) => {
        if (e.idTransferencia === idComprobante) {
          setRutCompletoTitular(formatterRut(e.rutTitular + e.dvTitular))
          setNombreTitular(e.nombreTitular)
          /* setTelefono(e.Telefono) */
          setCorreoTitular(e.correoTitular)

          bancos.map((i) => {
            if (i.key === e.idBanco) {
              setIdBanco(i.key);
              setValBanco(i)
            }
          })
          cuentas.map((i) => {
            if (i.key === e.idTipoCuenta) {
              setIdTipoCuenta(i.key);
              setValCuenta(i)
            }
          })

          setNumTransaccion(e.numTransaccion.toString())

          setMontoComprobante((e.montoPagado))
        }
      })
    } else {
      if (err != "500") {
        setOpenModalToken({ open: true, mnsj: err })
      }
    }
  }
  const handleSelectBanco = (event: any, newValue: any) => {
    if (newValue !== null) {
      setIdBanco(newValue.key);
      setValBanco(newValue);
    }
  }
  const handleSelectCuenta = (event: any, newValue: any) => {
    /* console.log(newValue) */
    if (newValue !== null) {
      setIdTipoCuenta(newValue.key);
      setValCuenta(newValue);
    }
  }
  const InsertInfoComprobante = () => {
    setGuardando(true)
    setGuardado(false)
    let _tt = JSON.stringify(location.state);
    let _params = JSON.parse(_tt)
    InsertTransferenciaLogic(selInsertComprobante, _params.headers, _params.rut, idProcesoItemPago, numTransaccion, rutTitular, dvTitular, nombreTitular, idBanco, idTipoCuenta, correoTitular, montoComprobante, guid, idEstadoInicial, usuario, idComprobante)
  }
  const selInsertComprobante = (error: Boolean, err: string, data: any) => {
    try {
      if (error === false) {
        setGuardado(data)
        setGuardando(false)
      } else {
        if (err != "500") {
          setOpenModalToken({ open: true, mnsj: err })
        } else {
          setGuardado(false)
          setGuardando(false)
        }
      }

    } catch (err) {
      console.log('error', err)
    }
  }
  const handleValidarDatos = () => {
    let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    //var today = new Date();
    try {
      if (rutCompletoTitular === "" || rutCompletoTitular === undefined) {
        setError("true");
        setMnsjError("Debe ingresar un rut del titular.");
      } else if ((nombreTitular === "" || nombreTitular === undefined)) {
        setError("true");
        setMnsjError("Debe ingresar el nombre del titular.");
      } /* else if (telefono === "" || telefono === "0" || telefono === undefined) {
        setError("true");
        setMnsjError("Debe ingresar el teléfono del titular.");
      } else if (telefono.length !== 9) {
        setError("true");
        setMnsjError("Debe ingresar teléfono correctamente.");
      } */ else if (correoTitular === "" || correoTitular === undefined) {
        setError("true");
        setMnsjError("Debe ingresar el Email del titular.");
      } else if (!regEmail.test(correoTitular)) {
        setError("true");
        setMnsjError("Debe ingresar un Email válido.");
      } /* else if (idBanco === 0) {
        setError("true");
        setMnsjError("Debe seleccionar un banco.");
      }  */else if (idTipoCuenta === 0) {
        setError("true");
        setMnsjError("Debe seleccionar un tipo de cuenta.");
      } else if (numTransaccion === "" || numTransaccion === "0" || nombreTitular === undefined) {
        setError("true");
        setMnsjError("Debe ingresar un número de transacción válido.");
      } else if (montoComprobante === 0) {
        setError("true");
        setMnsjError("Debe ingresar un monto de comprobante válido.");
      } else if (montoComprobante > saldoFaltante) {
        if (idComprobante != 0) {
          setError("false");
        } else {
          setError("true");
          setMnsjError("Monto excede el saldo faltante a pagar.");
        }
      } else {
        setError("false");
      }
    } catch (e: any) {
      setError("true");
      setMnsjError("Ocurrio un error al validar sus datos.");
    }
  }
  useEffect(() => {
    if (errorVal === "false") {
      InsertInfoComprobante()
    }
  }, [errorVal])

  return (

    <>
      {/* <Dialog open={openModalArchivos}
        maxWidth={"xl"}
        aria-labelledby="draggable-dialog-title">
        <DialogContent>
          <div style={{ fontFamily: 'sans-serif', textAlign: 'center', width: '100%' }}>
            {
              <div style={{ textAlign: 'center', padding: 10 }}>
                <h3>Información Comprobante</h3>
                <Grid container item xs={12} sm={12} md={12} direction="column" justifyContent="center" alignItems="stretch">
                  <Card elevation={0}>
                    <CardContent>
                      <Grid container direction="row" justifyContent="center" alignItems="stretch"  >
                        <Grid item xs={12} sm={5} md={5}>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">RUT remitente transferencia <span className="required">*</span></label>
                            <input id="firstnameinsured"
                              disabled={guardado}
                              className={estiloRut}
                              name="firstname"
                              maxLength={13}
                              placeholder={'99.999.999-9'}
                              type="text"
                              onChange={(e: any) => { setRutCompletoTitular(formatterRut(e.target.value.trim())) }}
                              value={rutCompletoTitular}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">Nombre remitente transferencia<span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              className="form-control js-will-validate"
                              type="text"
                              onChange={(e: any) => { setNombreTitular(e.target.value) }}
                              value={nombreTitular}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="mobile-phoneinsured">Teléfono remitente transferencia <span className="required">*</span></label>
                            <div className="personal-information__phones">
                              <span>+56</span>
                              <input id="mobile-phoneinsured"
                                name="mobile-phone"
                                disabled={guardado}
                                className="form-control js-mobile js-will-validate"
                                type="text"
                                pattern="[0-9]*"
                                maxLength={9}
                                max={9}
                                value={telefono}
                                onChange={(e: any) => setTelefono(e.target.value)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }} />
                            </div>
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">E-mail remitente transferencia<span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              className="form-control js-will-validate"
                              type="email"
                              onChange={(e: any) => setCorreoTitular(e.target.value)}
                              value={correoTitular}
                            />
                          </div>

                        </Grid>
                        <Grid item xs={1} sm={2} md={2}></Grid>
                        <Grid item xs={12} sm={5} md={5}>
                          <div className="form-group form-group--genero">
                            <p>Banco <span className="required">*</span></p>
                            <Autocomplete
                              style={{ marginTop: -25, marginBottom: -10 }}
                              id="listaBancos"
                              disabled={guardado}
                              value={valBanco}
                              options={bancos}
                              noOptionsText={'No existe la opción.'}
                              size='small'
                              getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                              onChange={handleSelectBanco}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  disabled={guardado}
                                  variant='outlined'
                                  placeholder="Seleccione Banco"
                                  margin="normal"
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                  }}
                                />
                              )}
                            />
                          </div>
                          <div className="form-group form-group--genero">
                            <p>Tipo Cuenta <span className="required">*</span></p>
                            <Autocomplete
                              style={{ marginTop: -25, marginBottom: -10 }}
                              id="listaCuentas"
                              disabled={guardado}
                              value={valCuenta}
                              options={cuentas}
                              noOptionsText={'No existe la opción.'}
                              size='small'
                              getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                              onChange={handleSelectCuenta}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  disabled={guardado}
                                  variant='outlined'
                                  placeholder="Seleccione Cuenta"
                                  margin="normal"
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                  }}
                                />
                              )}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">Código Transacción <span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              className="form-control js-will-validate"
                              type="text"
                              onChange={(e: any) => { setNumTransaccion(e.target.value) }}
                              value={numTransaccion}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">Monto<span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              className="form-control js-will-validate"
                              type="number"
                              onChange={(e: any) => { setMontoComprobante(parseInt(e.target.value)) }}
                              value={montoComprobante}
                            />
                          </div>

                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </div>
            }
          </div>
        </DialogContent>
        <DialogActions>
          {
            !guardando ?
              !guardado ?
                <Alert  variant="outlined" severity="warning">Ocurrió un problema al guardar el comprobante.</Alert>
                :
                <Alert  variant="outlined"
                  iconMapping={{
                    info: <CheckCircleOutline fontSize="inherit" />,
                  }}
                  severity="info">Comprobante guardado exitosamente.</Alert>
              : ""
          }
          {
            errorVal === "true" ?
              <Alert variant="outlined" severity="warning">{mnsjError}</Alert>
              :
              ""
          }


          <Button autoFocus onClick={() => {
            handleValidarDatos()
          }} disabled={guardado} color="primary" >Guardar</Button>
          <Button autoFocus onClick={() => {
            setRutTitular(0)
            setDvTitular('')
            setRutCompletoTitular('')
            setNombreTitular('')
            setTelefono('')
            setCorreoTitular('')
            setIdBanco(0)
            setValBanco(_banco)
            setValCuenta(_cuenta)
            setNumTransaccion('')
            setMontoComprobante(0)
            onClickModal(false)
            setEstiloRut('form-control js-rut js-will-validate')
            setGuardado(false)
            setGuardando(true)
            setError('')
            setMnsjError('')
          }} color="primary" >Salir</Button>
        </DialogActions>
      </Dialog> */}
      <Panel
        isOpen={openModalArchivos}
        type={PanelType.medium}
        hasCloseButton={false}
      >
        <DialogContent>
          <div style={{ fontFamily: 'sans-serif', width: '100%' }}>
            {
              <div style={{ padding: 10 }}>
                <h3>Información Comprobante</h3>
                <Grid container item xs={12} sm={12} md={12} direction="column">
                  <Card elevation={0}>
                    <CardContent>
                      <Grid container direction="row"  >
                        <Grid item xs={12} sm={12} md={12}>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">RUT remitente transferencia <span className="required">*</span></label>
                            <input id="firstnameinsured"
                              disabled={guardado}
                              className={estiloRut}
                              name="firstname"
                              maxLength={13}
                              placeholder={'99.999.999-9'}
                              type="text"
                              onChange={(e: any) => { setRutCompletoTitular(formatterRut(e.target.value.trim())) }}
                              value={rutCompletoTitular}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">Nombre remitente transferencia<span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              /* style={{ width: '40%' }} */
                              className="form-control js-will-validate"
                              type="text"
                              onChange={(e: any) => { setNombreTitular(e.target.value) }}
                              value={nombreTitular}
                            />
                          </div>
                          {/* <div className="form-group">
                            <label htmlFor="mobile-phoneinsured">Teléfono remitente transferencia <span className="required">*</span></label>
                            <div className="personal-information__phones">
                              <span>+56</span>
                              <input id="mobile-phoneinsured"
                                name="mobile-phone"
                                disabled={guardado}
                                className="form-control js-mobile js-will-validate"
                                type="text"
                                pattern="[0-9]*"
                                maxLength={9}
                                max={9}
                                value={telefono}
                                onChange={(e: any) => setTelefono(e.target.value)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }} />
                            </div>
                          </div> */}
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">E-mail remitente transferencia<span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              /* style={{ width: '40%' }} */
                              className="form-control js-will-validate"
                              type="email"
                              onChange={(e: any) => setCorreoTitular(e.target.value)}
                              value={correoTitular}
                            />
                          </div>

                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <div className="form-group form-group--genero">
                            <p>Banco <span className="required">*</span></p>
                            <ComboBox
                              style={{ marginTop: -8, /* marginBottom: -10,  */width: 300 }}
                              autoComplete='on'
                              placeholder='Seleccione Banco'
                              onChange={handleSelectBanco}
                              selectedKey={idBanco}
                              options={bancos}
                              disabled={guardado}
                            ></ComboBox>
                            {/* <Autocomplete
                              style={{ marginTop: -25, marginBottom: -10, width:'300px' }}
                              id="listaBancos"
                              disabled={guardado}
                              value={valBanco}
                              options={bancos}
                              noOptionsText={'No existe la opción.'}
                              size='small'
                              getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                              onChange={handleSelectBanco}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  disabled={guardado}
                                  variant='outlined'
                                  placeholder="Seleccione Banco"
                                  margin="normal"
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                  }}
                                />
                              )}
                            /> */}
                          </div>
                          <div className="form-group form-group--genero">
                            <p>Tipo Cuenta <span className="required">*</span></p>
                            <ComboBox
                              style={{ marginTop: -8, /* marginBottom: -10,  */width: 300 }}
                              autoComplete='on'
                              placeholder='Seleccione Banco'
                              onChange={handleSelectCuenta}
                              options={cuentas}
                              selectedKey={idTipoCuenta}
                              disabled={guardado}
                            ></ComboBox>
                            {/* <Autocomplete
                              style={{ marginTop: -25, marginBottom: -10 }}
                              id="listaCuentas"
                              disabled={guardado}
                              value={valCuenta}
                              options={cuentas}
                              noOptionsText={'No existe la opción.'}
                              size='small'
                              getOptionLabel={(options: IViewCombo) => toUpperCamelCase(options.descripcion)}
                              onChange={handleSelectCuenta}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  disabled={guardado}
                                  variant='outlined'
                                  placeholder="Seleccione Cuenta"
                                  margin="normal"
                                  fullWidth
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                  }}
                                />
                              )}
                            /> */}
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">Código Transacción <span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              className="form-control js-will-validate"
                              type="text"
                              onChange={(e: any) => {
                                var regex = new RegExp("^[a-zA-Z0-9 ]+$");
                                if (regex.test(e.target.value) || e.target.value.length === 0) {
                                  setNumTransaccion(e.target.value)
                                }
                              }}
                              value={numTransaccion}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="firstnameinsured">Monto<span className="required">*</span></label>
                            <input id="firstnameinsured"
                              name="firstname"
                              disabled={guardado}
                              /* style={{ width: '40%' }} */
                              className="form-control js-will-validate"
                              type="number"
                              onChange={(e: any) => { setMontoComprobante(parseInt(e.target.value)) }}
                              value={montoComprobante}
                            />
                          </div>

                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </div>
            }
          </div>
        </DialogContent>
        <DialogActions>
          {
            !guardando ?
              !guardado ?
                <Alert /* style={{ width: '20rem' }} */ variant="outlined" severity="warning">Ocurrió un problema al guardar el comprobante.</Alert>
                :
                <Alert /* style={{ width: '20rem' }} */ variant="outlined"
                  iconMapping={{
                    info: <CheckCircleOutline fontSize="inherit" />,
                  }}
                  severity="info">Comprobante guardado exitosamente.</Alert>
              : ""
          }
          {
            errorVal === "true" ?
              <Alert /* style={{ width: '20rem' }} */ variant="outlined" severity="warning">{mnsjError}</Alert>
              :
              ""
          }


          <Button autoFocus onClick={() => {
            handleValidarDatos()
          }} disabled={guardado} color="primary" >Guardar</Button>
          <Button autoFocus onClick={() => {
            setRutTitular(0)
            setDvTitular('')
            setRutCompletoTitular('')
            setNombreTitular('')
            setTelefono('')
            setCorreoTitular('')
            setIdBanco(0)
            setValBanco(_banco)
            setValCuenta(_cuenta)
            setNumTransaccion('')
            setMontoComprobante(0)
            onClickModal(false)
            setEstiloRut('form-control js-rut js-will-validate')
            setGuardado(false)
            setGuardando(true)
            setError('')
            setMnsjError('')
          }} color="primary" >Salir</Button>
        </DialogActions>
      </Panel>
      {
        openModalToken.open ?
          <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
          :
          ""
      }
    </>
  );
}

export default InfoComprobantes;
